<div class="img-splash">
    <img src="../../../assets/me.jpg" />
</div>
<div class="page-content">
    Hi! My name's Alex. I write software for a living and sometimes even for fun. You'll find a few of my more interesting personal projects here.
</div>
<div class="about">
    This site built in Angular 8.
</div>